export const URL_WHATSAPP_API = 'https://api.whatsapp.com';
export const NUMBER_PHONE_CX_TREINTA = '+1 (432) 741-3593';
export const CORE_PRODUCT_ARCHIVED_FLAG = "[!core_web_app_archived2022¡]";